import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

// The card a widget sits in: a white box on the off-white page, with a heading.
export default function WidgetCard({ title, icon: Icon, action, children }: {
  title: ReactNode;
  icon?: LucideIcon;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="border border-softgrey rounded-xl bg-white p-4">
      <div className="flex items-center gap-2 mb-3">
        {Icon && <Icon className="w-4 h-4 text-brand shrink-0" />}
        <h4 className="text-sm font-semibold text-graphite flex-1 min-w-0">{title}</h4>
        {action}
      </div>
      {children}
    </section>
  );
}
